import { useState } from "react";
import { createPortal } from "react-dom";

import { NavLink, useNavigate } from "react-router-dom";

export default function SideMenu() {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = (auth.role || "").toLowerCase().trim();

  const ADMIN_MENU = [
    { label: "Orders", path: "/pos/orders" },
    { label: "Users", path: "/pos/users" },
    { label: "Barcode", path: "/pos/barcode" },
    // { label: "QR Settings", path: "/pos/qr" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const SALES_MENU = [
    { label: "Sell", path: "/pos/sell" },
    { label: "Orders", path: "/pos/orders" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const MENU = role === "admin" ? ADMIN_MENU : SALES_MENU;

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  return (
    <>
      <nav className="p-4 space-y-2">
        {MENU.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `block px-3 py-2 rounded ${
                isActive ? "bg-blue-100 text-blue-600" : "hover:bg-gray-100"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}

        <hr className="my-3" />

        <button
          onClick={handleLogout}
          className="w-full text-left px-3 py-2 rounded hover:bg-red-100 text-red-600 font-medium"
        >
          Logout
        </button>
      </nav>

      {showLogoutModal &&
        createPortal(
          <div className="fixed inset-0 z-[99999] flex items-center justify-center">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setShowLogoutModal(false)}
            />

            {/* Modal */}
            <div className="relative z-[100000] bg-white w-[360px] rounded-2xl shadow-2xl p-6 animate-fadeIn">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 text-center">
                Logout
              </h2>

              <p className="text-sm text-gray-600 mb-6 text-center">
                Are you sure you want to logout?
              </p>

              <div className="flex justify-center gap-3">
                <button
                  onClick={() => {
                    localStorage.removeItem("auth");
                    navigate("/pos/login", { replace: true });
                  }}
                  className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg font-medium transition"
                >
                  Yes, Logout
                </button>

                <button
                  onClick={() => setShowLogoutModal(false)}
                  className="bg-gray-200 hover:bg-gray-300 px-5 py-2 rounded-lg font-medium"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
